import React from "react";
import { Form, Grid, Input } from "semantic-ui-react";
import BCAddressForm from "../ui/BCAddressForm";

const LOContactForm = ({ ...props }) => {
  const handleFormChange = (value, field) => {
    props.newContact[field] = value;
    props.setNewContact(props.newContact);
  };
  return (
    <div>
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>First Name: </label>
                <Input 
                  placeholder="John" 
                  onChange={(e) => handleFormChange(e.target.value, "firstName")}
                  type="text"
                  fluid 
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>Last Name: </label>
                <Input 
                  placeholder="Smith" 
                  onChange={(e) => handleFormChange(e.target.value, "lastName")}
                  type="text"
                  fluid 
                />
              </Form.Field>
            </Grid.Column>
            <BCAddressForm handleFormChange={handleFormChange} />
            <Grid.Column width={16}>
              <Form.Field className="profile-info-field">
                <label>Phone: </label>
                <Input 
                  placeholder="206-555-1234" 
                  onChange={(e) => handleFormChange(e.target.value, "phone")}
                  type="tel"
                  fluid 
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </div>
  );
};

export default LOContactForm;